import Vue from "vue";
import { createPkcePair, storePkceVerifier } from "@/utils/Pkce";

let instance;

const redirectToExternalLogin = async () => {
  const { codeVerifier, codeChallenge } = await createPkcePair();
  storePkceVerifier(codeVerifier);
  const targetUrl = `${process.env.VUE_APP_BACKEND_URL}/api/login/oauth/?pkce_code_challenge=${encodeURIComponent(codeChallenge)}`;
  window.location.assign(targetUrl);
};

const showLoginForm = () => {
  redirectToExternalLogin();
};

const LoginForm = function() {
  if (Vue.prototype.$isServer) return;

  showLoginForm();
};

LoginForm.show = () => {
  return LoginForm();
};

LoginForm.close = () => {
  if (!instance) return;

  instance.visible = false;
  setTimeout(() => {
    instance.active = false;
  }, 300);

  const wrapper = document.querySelector(".app-wrapper");
  if (wrapper) wrapper.classList.remove("has-popup");
};

export default LoginForm;
export { LoginForm };